import React, { Component } from 'react';
import './info-button.css';

import State from '../State'

class InfoButton extends Component {

  handleClick() {
    State.action('toggleInfo')
  }

  render() {
    return <svg width="18px" height="18px">
      <g transform="translate(9,9)" onClick={this.handleClick}>
        <circle r="9" style={{fill: 'rgb(255, 255, 255)'}}></circle>
        <circle r="9" style={{fill: '#474842'}}></circle>
        <line y1="-1" y2="6" style={{stroke: 'rgb(255, 255, 255)', strokeWidth: 3}}></line>
        <circle r="2" cy="-5" style={{fill: 'rgb(255, 255, 255)', strokeWidth: 3}}></circle>
      </g>
    </svg>
  }
}


export default InfoButton



// WEBPACK FOOTER //
// ./src/Controls/InfoButton.js